import React from 'react';
import { ChevronDown, ChevronRight, School, Layers } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/card';
import { formatMontant, formatNumber } from './recouvrementUtils';

// Section depliable + sous-section encadree + tableau a en-tete colore (patterns MaCaisse).
const ClassesConcerneesSection = ({ isExpanded, onToggleSection, classes }) => {
  const sections = classes.reduce((acc, classe) => {
    const key = classe.section_id ?? 'sans_section';
    if (!acc[key]) {
      acc[key] = { nom: classe.section_nom || 'Sans section', classes: [], reste: 0, eleves: 0 };
    }
    acc[key].classes.push(classe);
    acc[key].reste += Number(classe.reste_a_recouvrer || 0);
    acc[key].eleves += Number(classe.eleves_concernes || 0);
    return acc;
  }, {});

  const groupes = Object.values(sections);

  return (
    <div className="px-6">
      <Card>
        <CardHeader className="cursor-pointer hover:bg-gray-50 transition-colors" onClick={onToggleSection}>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              {isExpanded ? (
                <ChevronDown size={24} className="text-gray-600" />
              ) : (
                <ChevronRight size={24} className="text-gray-600" />
              )}
              <div>
                <CardTitle className="text-xl text-blue-600 flex items-center gap-2">
                  <Layers size={24} />
                  Répartition des créances
                </CardTitle>
                <p className="text-sm text-gray-500 mt-1">
                  lecture des impayés par section et par classe
                </p>
              </div>
            </div>
          </div>
        </CardHeader>

        {isExpanded && (
          <CardContent className="pt-6">
            {groupes.length === 0 ? (
              <div className="text-center py-12 bg-white rounded-lg border-2 border-dashed border-blue-200">
                <School size={48} className="mx-auto text-gray-400 mb-4" />
                <p className="text-gray-600 font-medium">Aucune classe à recouvrer</p>
                <p className="text-gray-500 text-sm mt-2">
                  Les classes concernées apparaîtront ici dès qu'une créance sera enregistrée
                </p>
              </div>
            ) : (
              <div className="space-y-6">
                {groupes.map((groupe) => (
                  <div key={groupe.nom} className="border-2 border-blue-200 rounded-lg bg-blue-50/30">
                    <div className="p-4 bg-blue-50 border-b border-blue-200">
                      <div className="flex items-center justify-between">
                        <h3 className="text-lg font-semibold text-blue-900 flex items-center gap-2">
                          <School size={20} />
                          {groupe.nom}
                        </h3>
                        <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-blue-100 text-blue-800">
                          {formatMontant(groupe.reste)}
                        </span>
                      </div>
                      <p className="text-sm text-blue-700 mt-1">
                        {groupe.classes.length} classe{groupe.classes.length > 1 ? 's' : ''} •{' '}
                        {formatNumber(groupe.eleves)} élève{groupe.eleves > 1 ? 's' : ''} concerné{groupe.eleves > 1 ? 's' : ''}
                      </p>
                    </div>

                    <div className="p-4">
                      <div className="overflow-x-auto">
                        <table className="w-full">
                          <thead className="bg-blue-100 border-b border-blue-200">
                            <tr>
                              <th className="px-4 py-3 text-left text-xs font-semibold text-blue-900 uppercase">Classe</th>
                              <th className="px-4 py-3 text-right text-xs font-semibold text-blue-900 uppercase">Élèves concernés</th>
                              <th className="px-4 py-3 text-right text-xs font-semibold text-blue-900 uppercase">Reste à recouvrer</th>
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-blue-100">
                            {groupe.classes.map((classe) => (
                              <tr key={`${classe.section_id}-${classe.classe_id}`} className="hover:bg-blue-50 transition-colors">
                                <td className="px-4 py-3">
                                  <p className="text-sm font-medium text-gray-900">{classe.classe_nom}</p>
                                </td>
                                <td className="px-4 py-3 text-right">
                                  <p className="text-sm text-gray-700">{formatNumber(classe.eleves_concernes)}</p>
                                </td>
                                <td className="px-4 py-3 text-right">
                                  <p className="text-sm font-bold text-[#c66d59]">{formatMontant(classe.reste_a_recouvrer)}</p>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </CardContent>
        )}
      </Card>
    </div>
  );
};

export default ClassesConcerneesSection;
